const steps = [
  {
    title: '課題ヒアリング',
    note: '無料',
    description: '現場の業務と課題をお聞きし、自動化する価値のある箇所を一緒に特定します。'
  },
  {
    title: '解決策のご提案',
    description: '具体的な解決イメージ・費用・期間をご提案。作らない方がよい場合は、そうお伝えします。'
  },
  {
    title: 'PoC（小規模検証）',
    description: '計算表1枚・帳票1種類など、最小単位で試作して効果を確認。リスクを抑えて判断できます。'
  },
  {
    title: '開発・導入',
    description: '現場に合わせて開発し、使い方の定着まで支援します。'
  },
  {
    title: '運用・改善',
    description: '導入後も継続サポート。現場の声を反映して育てていきます。'
  }
];

export default function ServiceFlow() {
  return (
    <section className="doc" id="flow">
      <div className="sheet">
        <p className="sec-label mono">SEC. 03 — 進め方</p>
        <h2>小さく試して、確かめてから本開発</h2>
        <p className="sec-intro">小さく早く開発します。効果を確認しながら、段階的に進めます。</p>
        <div className="steps">
          {steps.map((step) => (
            <div className="step" key={step.title}>
              <h3>
                {step.title}
                {step.note && <small>{step.note}</small>}
              </h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
